<template>
  <main><div class="page-heading"><div><p class="label">MIGRATION</p><h2>迁移控制台</h2></div></div><section class="panel"><p>迁移任务必须支持 dry-run、分批、断点、校验和最终追赶。任何写操作都需要后台权限和审计理由。</p></section></main>
</template>

